import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求角色列表
export const getroleList = params => {
    return get("/admin/roles", params);
};

// 修改信息
export const editrole = params => {
    return put(`/admin/roles/${params.id}`, params);
};

// 添加角色
export const addRole = params => {
    return post("/admin/roles", params);
};

// 删除角色
export const deleteRole = params => {
    return del(`/admin/roles/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/role.js